module.exports = "<gw-related-account-contacts\r\n        account-number=\"policy.account.accountNumber\"\r\n        page-size=\"$ctrl.pageSize\"\r\n        account-name=\"policy.account.accountHolder.displayName\"\r\n        relationship-keys-prefix=\"gateway.contacts.common.components.Contacts.AccountContacts.RelationshipDesc\"\r\n        detail-state=\"policies.detail.associated-contact-detail\"\r\n></gw-related-account-contacts>\r\n"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/gateway/contacts/common/views/policy-contact-related.html
// module id = 714
// module chunks = 0